import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table"
import { Attributes, Maybe } from "@/types/graphql.prod"
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table"

const columns: ColumnDef<Attributes | null>[] = [
  {
    accessorFn: (row) => row?.label,
    header: "Label",
  },
  {
    accessorFn: (row) => row?.value,
    header: "Value",
  },
]

export function ShowAttributeTable({
  data,
}: {
  data: Maybe<Maybe<Attributes>[]> | undefined
}) {
  const newData = data || []

  const table = useReactTable({
    data: newData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <Table className="w-full border-collapse">
      <TableBody>
        {table.getRowModel().rows.map((row) => (
          <TableRow
            key={row.id}
            className="border border-[rgba(173,173,173,0.3)]"
          >
            {row.getVisibleCells().map((cell, index) => (
              <TableCell
                key={cell.id}
                className={`border border-[#ddd] p-[16px] text-center font-poppins text-base text-[#000] ${index === 0 ? "w-fit whitespace-nowrap bg-[#F6F6F6] font-[600]" : " w-full pl-[14px]"}`}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
